import axios from "axios";

const api = axios.create({baseURL : 'https://api.flatearthevent.ir/v1'});

export default api;